<template>
  <router-view></router-view>
</template>
<script>

export default {
  name: 'app'
}
</script>

<style lang="scss">
  // CoreUI Icons Set

  @import 'assets/scss/style';
</style>



// WEBPACK FOOTER //
// src/App.vue